import { Link, useLocation } from 'react-router-dom'
import { Shield } from 'lucide-react'
import { useIsAdmin } from '@/hooks/useIsAdmin'
import { copy } from '@/lib/copy'
import { cn } from '@/components/ui/cn'

export function AdminNavLink({ onNavigate }: { onNavigate?: () => void }) {
  const isAdmin = useIsAdmin()
  const location = useLocation()
  const active = location.pathname.startsWith('/admin')

  if (!isAdmin) return null

  return (
    <Link
      to="/admin"
      onClick={onNavigate}
      data-testid="admin-nav"
      className={cn(
        'flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors',
        active
          ? 'bg-primary/10 font-medium text-primary'
          : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground',
      )}
    >
      <Shield className="h-4 w-4 shrink-0" />
      {copy.admin.navLabel}
    </Link>
  )
}
